import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import styled from "styled-components";
const Wrapper = styled.label`
  color: ${_ref => {
  let {
    $disabled,
    theme
  } = _ref;
  return $disabled ? theme.colors.text.disabled : theme.colors.text.primary;
}};
  font-family: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.typography.fontFamily.secondary;
}};
  font-weight: ${_ref3 => {
  let {
    theme
  } = _ref3;
  return theme.typography.fontWeight.medium;
}};
  display: inline-block;
  ${_ref4 => {
  let {
    $s,
    theme
  } = _ref4;
  return theme.spacing.resolve(theme, $s);
}};
`;
const Label = _ref5 => {
  let {
    disabled = false,
    required = false,
    s,
    children,
    ...rest
  } = _ref5;
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    $s: s,
    $disabled: disabled
  }, rest), children, required && " *");
};
export default Label;